"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportedPaymentDto = exports.ImportedInvoiceDto = exports.ImportedInvoiceLineDto = exports.ImportPaymentTypeEnum = void 0;
var ImportPaymentTypeEnum;
(function (ImportPaymentTypeEnum) {
    ImportPaymentTypeEnum["CREDIT_CARD"] = "card";
    ImportPaymentTypeEnum["ACH"] = "us_bank_account";
    ImportPaymentTypeEnum["CASH"] = "cash";
    ImportPaymentTypeEnum["CHECK"] = "check";
    ImportPaymentTypeEnum["CARD_ON_TERMINAL"] = "card-on-terminal";
    ImportPaymentTypeEnum["OTHER"] = "other";
    ImportPaymentTypeEnum["GIFT_CARD"] = "gift-card";
})(ImportPaymentTypeEnum = exports.ImportPaymentTypeEnum || (exports.ImportPaymentTypeEnum = {}));
class ImportedInvoiceLineDto {
}
exports.ImportedInvoiceLineDto = ImportedInvoiceLineDto;
class ImportedInvoiceDto {
}
exports.ImportedInvoiceDto = ImportedInvoiceDto;
class ImportedPaymentDto {
}
exports.ImportedPaymentDto = ImportedPaymentDto;
//# sourceMappingURL=invoices.dto.js.map